import script from "./Step1.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1.vue?vue&type=script&setup=true&lang=js"

import "./Step1.vue?vue&type=style&index=0&id=aa19482a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa19482a"]])

export default __exports__